// See FakeCell.tsx
export function FakeHeaderCell() {
  return <th data-testid="grid-fake-column-header" />;
}
